import React, { useState } from "react";
import { connect } from "react-redux";
import InspectionDetail from "./InspectionDetail";
import InspectionHistory from "./InspectionHistory";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import '../../../../App.scss'

const InspectionDetailTabs = () => {
    return (
        <div>
            <TabPanel className="review-tabs h-100">
                <Item className="h-100" title="New Inspection" style={{ textTransform: "math-auto" }}>
                    <InspectionDetail></InspectionDetail>
                </Item>
                <Item title="Inspection History" style={{ textTransform: "math-auto" }}>
                    <InspectionHistory></InspectionHistory>
                </Item>
            </TabPanel>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(InspectionDetailTabs);